import React, { useEffect } from 'react';
import {
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';
import UnarchiveOutlinedIcon from '@material-ui/icons/UnarchiveOutlined';

import Api from '../../Helper/ApiHandler';
import { validate } from 'validate.js';
import { Data } from '@react-google-maps/api';
var api = new Api();

const schema = {
  Title: {
    presence: { allowEmpty: false, message: 'Title is required' }
  },
  Description: {
    presence: { allowEmpty: false, message: 'Description is required' }
  },
  file: {
    presence: { allowEmpty: false, message: 'Image is required' }
  }
};

const useStyles = makeStyles(() => ({
  root: {},
  dialogButtonHeader: {
    display: 'flex',
    justifyContent: 'center',
    padding: '30px 10px 10px 10px',
    '& .MuiButton-root': {
      // textTransform: 'capitalize'
    }
  },
  divider: {
    '& .MuiDivider-root': {
      backgroundColor: '#0000002b'
    }
  },
  dialogRoot: {
    padding: '10px',
    '& .MuiDialog-paper': {
      // overflow: "visible"
      // height: '440px',
      width: '500px',
      borderRadius: '10px'
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgb(0 0 0 / 55%)'
    },
    '& .MuiPaper-elevation24': {
      // boxShadow: 'none'
    }
  },
  btnSave: {
    borderRadius: '5px',
    fontSize: '12px',
    backgroundImage:
      'linear-gradient(261.94deg, #FFD24C 0%, #FFD24C 46.4%, #FFEF33 100%)',
    color: 'white',
    textTransform: 'uppercase',
    width: '120px'
  },
  btnCancel: {
    borderRadius: '5px',
    fontSize: '12px',
    width: '120px'
  },
  flexWithPading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
    '& .MuiOutlinedInput-root .MuiOutlinedInput-input': {
      fontSize: '14px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '6px'
    },
    '& .MuiIconButton-root': {
      padding: '0 12px'
    }
  },
  flex: {
    display: 'flex',
    justifyContent: 'flex-start',
    '& .MuiTypography-body1': {
      fontWeight: 'bold',
      fontSize: '16px'
    }
  },
  title: {
    fontWeight: 500
  },
  subTitle: {
    opacity: 0.3,
    fontWeight: 500
  },
  imgMainContainer: {
    display: 'flex'
  },
  ImgContainer: {
    marginTop: '0'
  },
  uploadImg: {
    width: '30px',
    height: '30px',
    objectFit: 'contain'
  }
}));
function PushNotificationModal(props) {
  const classes = useStyles();
  const {
    userType,
    componentName,
    setSessionMessage,
    slug,
    onload,
    onClose,
    open
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [uploadImgPath, setUploadImgPath] = React.useState('');

  const [formState, setFormState] = React.useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  const handleClose = () => {
    onClose();
    setFormState({
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    });
  };

  useEffect(() => {
    const errors = validate(formState.values, schema, { fullMessages: false });

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
    // console.log(formState.values, 'formState.values');
    console.log(formState.errors, 'formState.errors');
  }, [formState.values]);

  const handleFieldChange = event => {
    event.persist();
    console.log(event.target.value, 'event.target.value');
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const onUploadimageChange = (event, name) => {
    const file = event.target.files[0];
    // Base64
    var reader = new FileReader();
    reader.onloadend = function() {
      setUploadImgPath(reader.result);
    };

    reader.readAsDataURL(file);

    setFormState({
      ...formState,
      values: {
        ...formState.values,
        file: file
      }
    });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    const data = new FormData();

    data.append('title', formState.values.Title);
    data.append('description', formState.values.Description);
    data.append('file', formState.values.file);

    if (formState.isValid === true) {
      setDisabled(true);
      setLoading(true);
      api
        .post('admin/addsendpushnotify', {
          data: data
        })
        .then(result => {
          if (result.success === 'true') {
            setSessionMessage({
              message: result.message,
              type: 'success',
              open: true
            });
            onClose();
            onload();
          } else {
            console.log(result, 'result');
            setSessionMessage({
              message: result.message,
              type: 'error',
              open: true
            });
          }
          setDisabled(false);
          setLoading(false);
        })
        .catch(err => {
          console.log(err, 'error catch');
          setDisabled(false);
          setLoading(false);
          setSessionMessage({
            message: err.message,
            type: 'error',
            open: true
          });
        });
    }
  };

  return (
    <Dialog
      className={classes.dialogRoot}
      onClose={handleClose}
      // maxWidth="xs"
      open={open}>
      <Grid container justify="center" style={{ padding: '25px' }}>
        <Grid item xs={12} className={classes.flex}>
          <Typography>Push Notification</Typography>
        </Grid>
      </Grid>
      <div className={classes.divider}>
        <Divider />
      </div>
      <form onSubmit={handleSubmit}>
        <Grid container justify="center" style={{ padding: '20px' }}>
          <Grid item xs={12} className={classes.flexWithPading}>
            <TextField
              required
              size="small"
              InputLabelProps={{
                classes: {
                  asterisk: classes.asterisk
                }
              }}
              fullWidth
              error={hasError('Title')}
              type="text"
              helperText={hasError('Title') ? formState.errors.Title[0] : null}
              label="Title"
              name="Title"
              onChange={handleFieldChange}
              value={formState.values.Title || ''}
              variant="outlined"
              // size="small"
            />
          </Grid>
          <Grid item xs={12} className={classes.flexWithPading}>
            <TextField
              multiline={true}
              rows={5}
              required
              size="small"
              InputLabelProps={{
                classes: {
                  asterisk: classes.asterisk
                }
              }}
              fullWidth
              error={hasError('Description')}
              type="text"
              helperText={
                hasError('Description') ? formState.errors.Description[0] : null
              }
              label="Description"
              name="Description"
              onChange={handleFieldChange}
              value={formState.values.Description || ''}
              variant="outlined"
              // size="small"
            />
          </Grid>
          <Grid
            classes={classes.imgMainContainer}
            item
            xs={12}
            className={classes.flexWithPading}>
            <FormControl size="small" variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-password">
                Upload Image
              </InputLabel>
              <OutlinedInput
                size="small"
                id="icon-button-file"
                type={'text'}
                className={classes.upload}
                // value={uploadImage}
                labelWidth={100}
                readOnly={true}
                endAdornment={
                  <>
                    <input
                      accept="image/png, image/jpg, image/jpeg"
                      className={classes.input}
                      style={{ display: 'none' }}
                      id="raised-button-file"
                      type="file"
                      name="file"
                      onChange={e => {
                        onUploadimageChange(e);
                      }}
                    />
                    <label htmlFor="raised-button-file">
                      <IconButton aria-label="upload picture" component="span">
                        <UnarchiveOutlinedIcon />
                      </IconButton>
                    </label>
                  </>
                }
              />
            </FormControl>
            {uploadImgPath && (
              <IconButton className={classes.ImgContainer}>
                <img className={classes.uploadImg} src={uploadImgPath} />
              </IconButton>
            )}
          </Grid>
          <Grid item xs={12}>
            <div className={classes.dialogButtonHeader}>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  handleClose();
                }}
                className={classes.btnCancel}>
                Cancel
              </Button>
              &nbsp;&nbsp;
              <Button
                color="primary"
                variant="contained"
                className={classes.btnSave}
                type="submit"
                disabled={formState.isValid ? disabled : true}>
                Save &nbsp;
                {loading ? <CircularProgress size={20} /> : ''}
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </Dialog>
  );
}

export default PushNotificationModal;
